<template>
  <sui-segment>
    <v-container>
      <v-toolbar>
        <!-- <v-col cols="2">
          <v-select
            v-model="sort"
            :items="sortby"
            item-value="val"
            item-text="label"
            :label="$t('sortby')"
            return-object
            single-line
            @change="handleChangeSortby"
          ></v-select>
        </v-col> -->
        <v-col cols="2">
          <v-text-field
            :label="$t('search')"
            v-model="search"
            clearable
            append-icon="mdi-magnify"
            @click:clear="handleClearSearch"
            @click:append="handleSearch"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
        <v-select
            v-model="sortcategories"
            :items="allcategories"
          :label="$t('sortByCat')"
            multiple
        item-text="name"
        item-value="id"
        clearable
        @focus="handleCategoryClick"
        @click:clear="newCategorySearch(true)"
        @blur="newCategorySearch(false)"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip :color="item.color" v-if="index < 2">
          <span>{{ item.name }}</span>
        </v-chip>
        <span
          v-if="index >= 2"
          class="grey--text text-caption"
        >
        <div v-if="index == 2">
          (+{{ sortcategories.length - 2}} others)
        </div>
        </span>
      </template>
    </v-select>
        </v-col>
        <v-col cols="6">
          <!-- <div v-if="sortcat">
            <v-chip
              style="margin-right: 12px"
              v-for="sort in sortcat"
              :key="sort.id"
                  :style="'background-color:' + sort.color"
              close
              @click:close="removeSort(sort)"
              >{{ sort.name }}</v-chip
            >
          </div> -->
        </v-col></v-toolbar
      >
      <br />
      <v-row v-if="loading">
        <v-col cols="12" md="4" v-for="i in 3" :key="i">
          <v-skeleton-loader
            v-bind="attrs"
            type=" image,article"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-bind="attrs"
            type="image,article"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-else-if="noData" class="red--text lighten-1" style="justify-content:center;">
        <div style="margin:.7rem;font-size:1.5rem;font-weight:bold">
          {{$t("noProductsFound")}}
        </div>
      </v-row>
      <v-row v-else>
        <v-card
          v-for="prod in products"
          :key="prod.id"
          class="mx-auto my-12 prod-card"
          width="374"
          @click="handleClickCard(prod)"
        >
          <v-img
            height="250"
            :src="prod.image"
          ></v-img>

          <v-card-title>{{ prod.name }}</v-card-title>

          <v-card-text>
            <div>{{ prod.shortdescription }}</div>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-text>
            <div class="my-4 text-subtitle-1">
              <!-- {{ $t("price") }}:
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(prod.price)
              }} -->
              <v-btn
                style="float: inline-end"
                @click.prevent="handleAddToCart(prod)"
                color="blue darken-2"
              >
                <v-icon :title="$t('addToCart')">mdi-cart</v-icon>
              </v-btn>
            </div>
          </v-card-text> 
          <!-- <v-divider class="mx-4"></v-divider> -->
          <v-card-text v-if="prod.groups != null &&prod.groups.length > 0">
            <span>{{$t("groups")}}</span>
            <v-chip-group column>
              <v-chip
              style="margin-right: 12px"
                v-for="group in prod.groups"
                :key="group"
                :color="group.color"
                >{{ $t(group.name) }}</v-chip
              >
            </v-chip-group>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-text v-if="prod.categories != null && prod.categories.length > 0">
            <span>{{$t("categories")}}</span>
            <v-chip-group v-model="selection" column>
              <v-chip
              style="margin-right: 12px"
                @click.prevent="addSortCat(cat)"
                v-for="cat in prod.categories"
                :key="cat.id"
                :color="cat.color"
                >{{ cat.name }}</v-chip
              >
            </v-chip-group>
          </v-card-text>
        </v-card>

        <hr />
      </v-row>
    </v-container>

      <sui-modal v-model="showModal" width="500">
      <sui-modal-header
        ><v-icon large>mdi-cart</v-icon> {{ $t("addToCart") }}</sui-modal-header
      >
      <sui-modal-content scrolling image>
        <v-row>
          <v-col cols="12" md=6>
            
        <sui-image class="prod-img" :src="currProd.image"></sui-image>         
         <!-- <p>
            {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(currProd.newprice)
            }}
          </p> -->
          <div>
            <div v-for="extra in currProd.extras" :key="extra">
					<div v-if="extra.extras.length > 0">
						<v-row>
							<v-col cols=2> 
							<h3>{{$t(extra.name)}}</h3>
							</v-col>
							<v-col v-if="selectedExtras[extra.name]">
								 {{ selectedExtras[extra.name] ? $t('selected') + ": " + $t(renderExtra(selectedExtras[extra.name]))  : ""}}
							</v-col>
						</v-row>
						      <v-btn-toggle
							   v-if="extra.name != 'color'"
								mandatory
								v-model="selectedExtras[extra.name]"
								color="primary"
								>
								<div :key="ext" v-for="ext in extra.extras" :title="ext.name">
									<v-btn @click.prevent="handleChangeExtras(extra,ext)" fab :value="ext.id">
										{{ shortName(ext.name)}}
									</v-btn>&nbsp;
								</div>
							</v-btn-toggle>
						      <v-btn-toggle
							  	v-else
								mandatory
								v-model="selectedExtras[extra.name]"
								color="primary"
								>
								<div :key="ext" v-for="ext in extra.extras">
									<v-btn @click.prevent="handleChangeExtras(extra,ext)" fab :value="ext.id" :color="ext.style" :title="ext.name">
										{{shortName(ext.name)}}
									</v-btn>&nbsp;
								</div>
							</v-btn-toggle>
					<sui-divider></sui-divider>
					</div>
				</div>
          </div>
          <v-text-field
            v-model="currProd.amount"
            type="number"
            min="1"
            max="99"
            :label="$t('amount')"
          ></v-text-field>
          <v-chip
          v-for="cat in currProd.categories"
              style="margin-right: 12px"
                :key="cat.id"
                :style="'background-color:'+cat.color"
                >{{ cat.name }}</v-chip
              >
          </v-col>
          <v-col cols="12" md=6 style="max-height: 100%;">
            
          <sui-header>{{ currProd.name }}</sui-header>
          <p style="max-height: 90%; overflow-Y: auto;">
            {{ currProd.description }}
          </p>
          </v-col>
        </v-row>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click.native="addToCart">
          {{ $t("add") }}
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
  </sui-segment>
</template>

<script>
import ApiService from "@/services/ApiService.js";
export default {
  props: {
    globalSearch: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: true,
      attrs: {
        class: "mb-6",
        // boilerplate: true,
        elevation: 2,
      },
      products: null,
      sortcat: [],
      categories: [],
      allcategories: [],
      sortcategories: [],
			selectedExtras: [],
      sort: {},
      showModal: false,
      currProd: {},
    //   sortby: [
    //     { val: "priceASC", label: this.$t("priceASC") },
    //     { val: "priceDESC", label: this.$t("priceDESC") },
    //   ],
      search: null,
      limit: 8,
      limits: [10, 15, 30, 50, 100],
      start: 0,
      selectedCategories: [],
      rendering: false,
      renderedall: false,
      noClick: false,
      noData: false,
			extras: {}
    };
  },
  async created() {
    this.init();
    this.rendercontent();
  },
  mounted () {
    window.addEventListener("scroll", this.scroll, true)
  },
  destroyed () {
    window.removeEventListener("scroll", this.scroll, true)
  },
  methods: {
    scroll(){
    
        if (document.body.offsetHeight + document.body.scrollTop >= document.body.scrollHeight / 2 && !this.rendering && !this.renderedall) {
          this.start += this.limit
        this.rendering = true
          this.rendercontent()
        }
    },
    handleChangeExtras(extraCat, extra){
			this.selectedExtras[extraCat.name] = extra.id;
      console.log(extraCat.name)
      console.log(extra)
      console.log(this.selectedExtras)
      this.$forceUpdate()
		},
    async init() {
      const url = new URL(window.location.href);
      const urlParams = url.searchParams;
      let param = urlParams.get("category");
      if(param != null){
        window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
      }
      let res = await ApiService.getCategories();
      if (res.status == 200) {
        this.allcategories = res.data.data;

      }
      if(param != null){
        this.allcategories.forEach(element => {
          console.log(element)
          if(element.id == param){
              this.addSortCat(element)
          }
        });
      }
    },
    handleChangeSortby(){
      this.loading = true;
      this.products= null;
      this.rendercontent()
    },
    async rendercontent() {
      this.noData = false
      let resp = await ApiService.postProducts({
        search: this.search,
        sortAs: this.sort.val,
        limit: this.limit,
        start: this.start
      });
      if (resp.status == 200) {
        this.products == null ? this.products = resp.data.data : resp.data.data.forEach(element => {
           this.products.push(element);
        }); 
        this.products == null || this.products.length == 0 ? this.noData = true : ""
        this.loading = false;
        this.rendering = false;
        resp.data.end ? this.renderedall = true : ""
      }
    },
    renderExtra(extra){
      console.log(extra)
			if(this.extras !== undefined)
			return this.extras[extra]
		},
		shortName(str){
			if(str.length < 6){
				return this.$t(str)
			}else{
				return this.$t(str.slice(0, 3) + "..")
			}
		},
    handleCategoryClick(){
      this.sortcat = this.sortcategories
    },
    async newCategorySearch(clear){
      this.start = 0;
      this.noData = false
      if(this.sortcat == this.sortcategories){
        return
      }
      if(this.sortcat.length ==0 && this.sortcategories.length == 0){
        return
      }

      this.loading = true    
      if(clear == true){
        this.sortcategories = [] 
      }
      
        this.products = null
      if (this.sortcategories.length == 0) {
        this.rendercontent();
        this.renderedall = true;
        return;
      } else {
        let resp = await ApiService.sortByCategories({ categories: this.sortcategories });
        if (resp.status == 200) {
          this.products = resp.data;
          this.products.length == 0 ? this.noData = true : ""
          this.loading = false;
        }
      }
    },
    async addSortCat(cat) {
      if (this.sortcategories.indexOf(cat) === -1) this.sortcategories.push(cat);
      this.newCategorySearch();
    },
    async handleClearSearch(){
      if(this.search != null)
        this.search = "";
        this.loading = true
        this.products = null
        this.rendercontent()
    },
    async handleSearch(){
      if(this.search == null || this.search  == "" ){
        return;
      }
      this.start = 0;
      this.limit = 0;
      this.products = null
      this.loading = true
            window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
      this.rendercontent()
    },
    async handleAddToCart(item) {
        // this.$router.push("/product/"+item.id)
      this.noClick = true
      this.currProd = item;
    //   this.currProd.newprice = this.currProd.price;
      
     let res = await ApiService.getExtras(item.id)
      if(res.status == 200){
      this.extras = res.data
      }
      if(this.selectedExtras.length == 0){
        this.currProd.extras.forEach(el => {
          this.selectedExtras[el.name] = el.extras[0]
        });
      }
      this.showModal = true;
      this.currProd.amount = 1;
      this.noClick = false
    },
    async addToCart() {
      let res = await ApiService.addToCart({
        product_id: this.currProd.id,
        amount: this.currProd.amount,
        color: this.selectedExtras["color"],
		    size: this.selectedExtras["size"],
      });
      if (res.status == 201) {
        this.$swal(this.$t("yea"), this.$t("added"), "success");
        this.showModal = false;
		    this.$emit("updateNotis")
      } else {
        this.$swal(this.$t("error"), this.$t(res.data.message), "error");
      }
    },
    async handleGlobalSearch() {
      let searchList = this.globalSearch.split(" ");
      let search = "";
      for (var i = 1; i < searchList.length; i++) {
        search == "" ? "" : (search += " ");
        search += searchList[i];
      }

      let resp = await ApiService.postSearchCatalog({ search: search });
      if (resp.status == 200) {
        this.products = resp.data.data;
      }
    },
    async handleClickCard(card){
      // console.log(card)
      if(this.noClick != true && this.showModal != true){
        this.$router.push("/product/"+card.id)
      }
    }
  },
  watch: {
    globalSearch() {
      this.handleGlobalSearch();
    },
     '$route.query.search': {
        handler: function(search) {
          if(search != undefined && search != null){
            console.log(search)
            this.products = null
            this.loading = true
            window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
            this.search = search
            this.rendercontent()
          }
        },
        deep: true,
        immediate: true
      },
      selectedExtras: function() {
        console.log("abc")
        this.$forceUpdate();
      }
  },
};
</script>
<style>
.prod-img {
  max-height: 250px;
  max-width: 250px;
}
.prod-card:hover {
  /* opacity: .7; */
  cursor: pointer;
}
/* .sort-select {
	width: 30%;;
} */
</style>